export default [
  {
    name: 'Client.Deals',
    path: 'deals',
    component: () => import('./components/deals/List'),
    meta: { wide: true }
  },
  {
    name: 'Client.Deals.Show',
    path: 'deals/:id',
    props: true,
    component: () => import('./components/deals/Show')
  },
  {
    name: 'Client.ScheduleAssign',
    path: 'schedule/assign',
    component: () => import('./components/schedule/ScheduleAssign'),
    meta: { wide: true }
  }
]
